import validUrl from 'valid-url';

export default class ValidationUtils {
  static checkEmail(email, fieldName) {
    const regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;
    if (email && !regex.test(email)) {
      const prefix = fieldName ? `${fieldName}: ` : '';
      return `${prefix}Please enter a valid email address.`;
    }
  }

  static checkUrl(url, fieldName) {
    if (url && !validUrl.isWebUri(url)) {
      const prefix = fieldName ? `${fieldName}: ` : '';
      return `${prefix}Please enter a valid URL.`;
    }
  }
}
